export type CommonCssIdType = { [x in CommonCssId]: boolean }

export enum CommonCssId {
  COMMON_CSS = 'COMMON_CSS',
  COMMON_AC_PANEL_CSS = 'COMMON_AC_PANEL_CSS',
  COMMON_SW_CSS = 'COMMON_SW_CSS',
}

export const commonSwCss =
  // tslint:disable-next-line:prefer-template
  'body {' +
  '  background-color: #e9ecef;' +
  '}' +
  '' +
  '#content {' +
  '  margin-bottom: 13px;' +
  '}' +
  '' +
  '/* RMCPLAYER - 재생 전 검은배경 투명도 조절 */' +
  '.u_rmcplayer .u_rmcplayer_layer {' +
  '  background-color: rgba(0, 0, 0, 0.3) !important;' +
  '}' +
  '' +
  '/* 스마트에디터 */' +
  '.editor_wrap {' +
  '  margin-bottom: 7px;' +
  '  padding: 20px 0;' +
  '  background-color: #fff;' +
  '}' +
  '' +
  '.full_height {' +
  '  width: auto !important;' +
  '  height: 100% !important;' +
  '}' +
  '' +
  '/* 패션윈도(백화점/아울렛/스타일) 태크 색상 */' +
  '.fashion_tag_color1 {' +
  '  background-color: #f6b737;' +
  '}' +
  '.fashion_tag_color2 {' +
  '  background-color: #e95c22;' +
  '}' +
  '.fashion_tag_color3 {' +
  '  background-color: #df7782;' +
  '}' +
  '.fashion_tag_color4 {' +
  '  background-color: #839973;' +
  '}' +
  '.fashion_tag_color5 {' +
  '  background-color: #0fa573;' +
  '}' +
  '.fashion_tag_color6 {' +
  '  background-color: #06796a;' +
  '}' +
  '.fashion_tag_color7 {' +
  '  background-color: #2eadb2;' +
  '}' +
  '.fashion_tag_color8 {' +
  '  background-color: #b468ea;' +
  '}' +
  '.fashion_tag_color9 {' +
  '  background-color: #d23a95;' +
  '}' +
  '.fashion_tag_color10 {' +
  '  background-color: #6c49b8;' +
  '}' +
  '.fashion_tag_color11 {' +
  '  background-color: #84136d;' +
  '}' +
  '.fashion_tag_color12 {' +
  '  background-color: #60365e;' +
  '}' +
  '.fashion_tag_color13 {' +
  '  background-color: #123a5d;' +
  '}' +
  '.fashion_tag_color14 {' +
  '  background-color: #003f7e;' +
  '}' +
  '.fashion_tag_color15 {' +
  '  background-color: #78bddb;' +
  '}' +
  '.fashion_tag_color16 {' +
  '  background-color: #6b6da6;' +
  '}' +
  '.fashion_tag_color17 {' +
  '  background-color: #c779b7;' +
  '}' +
  '.fashion_tag_color18 {' +
  '  background-color: #ad58af;' +
  '}' +
  '.fashion_tag_color19 {' +
  '  background-color: #89879f;' +
  '}' +
  '' +
  '/* 스타일윈도 태그 색상 */' +
  '.style .tag_color_set1 .tag_color1 {' +
  '  background-color : #bd57e3;' +
  '}' +
  '.style .tag_color_set1 .tag_color2 {' +
  '  background-color : #7d4ba2;' +
  '}' +
  '.style .tag_color_set1 .tag_color3 {' +
  '  background-color : #a6a0bb;' +
  '}' +
  '.style .tag_color_set1 .tag_color4 {' +
  '  background-color : #9d4794;' +
  '}' +
  '.style .tag_color_set1 .tag_color5 {' +
  '  background-color : #9f8ca5;' +
  '}' +
  '.style .tag_color_set1 .tag_color6 {' +
  '  background-color : #8f90b6;' +
  '}' +
  '.style .tag_color_set1 .tag_color7 {' +
  '  background-color : #ae82c4;' +
  '}' +
  '.style .tag_color_set1 .tag_color8 {' +
  '  background-color : #634c8a;' +
  '}' +
  '.style .tag_color_set2 .tag_color1 {' +
  '  background-color : #753eb2;' +
  '}' +
  '.style .tag_color_set2 .tag_color2 {' +
  '  background-color : #8f78c6;' +
  '}' +
  '.style .tag_color_set2 .tag_color3 {' +
  '  background-color : #aa8dc7;' +
  '}' +
  '.style .tag_color_set2 .tag_color4 {' +
  '  background-color : #913d88;' +
  '}' +
  '.style .tag_color_set2 .tag_color5 {' +
  '  background-color : #9b9db3;' +
  '}' +
  '.style .tag_color_set2 .tag_color6 {' +
  '  background-color : #ac8daf;' +
  '}' +
  '.style .tag_color_set2 .tag_color7 {' +
  '  background-color : #9f3f79;' +
  '}' +
  '.style .tag_color_set2 .tag_color8 {' +
  '  background-color : #a28d99;' +
  '}' +
  '.style .tag_color_set3 .tag_color1 {' +
  '  background-color : #884da7;' +
  '}' +
  '.style .tag_color_set3 .tag_color2 {' +
  '  background-color : #9954ae;' +
  '}' +
  '.style .tag_color_set3 .tag_color3 {' +
  '  background-color : #9b42a4;' +
  '}' +
  '.style .tag_color_set3 .tag_color4 {' +
  '  background-color : #c27cc9;' +
  '}' +
  '.style .tag_color_set3 .tag_color5 {' +
  '  background-color : #634a91;' +
  '}' +
  '.style .tag_color_set3 .tag_color6 {' +
  '  background-color : #a88ec0;' +
  '}' +
  '.style .tag_color_set3 .tag_color7 {' +
  '  background-color : #947cb0;' +
  '}' +
  '.style .tag_color_set3 .tag_color8 {' +
  '  background-color : #b285ab;' +
  '}'

export const ac_panelCss =
  // tslint:disable-next-line:prefer-template
  '.ac_panel .ac_img_wrap .ac_play,' +
  '.ac_panel .ac_btn_zoom {' +
  '  font-size: 0;' +
  '  line-height: 0;' +
  '  color: transparent;' +
  '}' +
  '' +
  '.ac_panel .ac_img_wrap .ac_play,' +
  '.ac_panel .ac_btn_zoom:before {' +
  '  background: url(./img/sp_ac_panel.png) no-repeat;' +
  '  background-size: 75px auto;' +
  '  -webkit-background-size: 75px auto;' +
  '}' +
  '' +
  '.ac_basis {' +
  '  font-size: 13px;' +
  '  line-height: 18px;' +
  '  color: #bfbfbf;' +
  '}' +
  '' +
  '.ac_pointer {' +
  '  color: #666;' +
  '}' +
  '' +
  '.ac_font_bold {' +
  '  font-weight: bold;' +
  '}' +
  '' +
  '.ac_font_italic {' +
  '  font-style: italic;' +
  '}' +
  '' +
  '.ac_font_underline {' +
  '  text-decoration: underline;' +
  '}' +
  '' +
  '.ac_align_left {' +
  '  text-align: left;' +
  '}' +
  '' +
  '.ac_align_center {' +
  '  text-align: center;' +
  '}' +
  '' +
  '.ac_font_del {' +
  '  text-decoration: line-through;' +
  '}' +
  '' +
  '.ac_comp_wrap {' +
  '  position: relative;' +
  '  outline-style: none;' +
  '}' +
  '' +
  '.ac_panel {' +
  '  overflow: hidden;' +
  '  position: relative;' +
  '}' +
  '.ac_panel .ac_img_wrap {' +
  '  max-width: 450px;' +
  '  margin: 9px auto 0;' +
  '  padding-top: 5px;' +
  '  padding-bottom: 5px;' +
  '  text-align: center;' +
  '}' +
  '.ac_panel .ac_img_wrap img {' +
  '  width: 100%;' +
  '  border: 0;' +
  '  outline-style: none;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_box {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_image_caption {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '  min-height: 15px;' +
  '  padding: 9px 0 3px 7px;' +
  '  font-size: 13px;' +
  '  line-height: 17px;' +
  '  color: #777;' +
  '  text-align: left;' +
  '  word-break: break-all;' +
  '  outline-style: none;' +
  '  overflow: hidden;' +
  '  white-space: normal' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_image_caption br {' +
  '  display: none;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_image_caption div {' +
  '  display: inline;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_image_caption:before {' +
  '  display: block;' +
  '  position: absolute;' +
  '  left: 0;' +
  '  top: 11px;' +
  '  width: 2px;' +
  '  height: 10px;' +
  '  background-color: #7f93af;' +
  "  content: '';" +
  '}' +
  '.ac_panel .ac_img_wrap .ac_play {' +
  '  display: block;' +
  '  overflow: hidden;' +
  '  position: absolute;' +
  '  left: 50%;' +
  '  top: 50%;' +
  '  margin: -31px 0 0 -31px;' +
  '  width: 61px;' +
  '  height: 61px;' +
  '  background-position: 0 0;' +
  '  vertical-align: top;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_movie {' +
  '  display: block;' +
  '  width: 100%;' +
  '  min-height: 185px;' +
  '  background-color: #e5e5e5;' +
  '}' +
  '.ac_panel .ac_img_wrap .ac_movie_link {' +
  '  display: -webkit-box;' +
  '  overflow: hidden;' +
  '  position: absolute;' +
  '  bottom: 0;' +
  '  left: 0;' +
  '  right: 0;' +
  '  z-index: 10;' +
  '  max-height: 26px;' +
  '  padding: 5px;' +
  '  background-color: #cecece;' +
  '  outline-style: none;' +
  '  font-size: 12px;' +
  '  color: #999999;' +
  '  text-align: left;' +
  '  text-overflow: ellipsis;' +
  '  -webkit-line-clamp: 2;' +
  '  -webkit-box-orient: vertical;' +
  '  word-break: break-all;' +
  '}' +
  '.ac_panel .ac_btn_zoom {' +
  '  display: none;' +
  '  overflow: hidden;' +
  '  position: absolute;' +
  '  right: 10px;' +
  '  bottom: 10px;' +
  '  width: 24px;' +
  '  height: 24px;' +
  '  border-radius: 100%;' +
  '  background: rgba(0, 0, 0, 0.4);' +
  '  box-shadow: 0 0 1px rgba(255, 255, 255, 0.4);' +
  '}' +
  '.ac_panel .ac_btn_zoom:before {' +
  '  display: none;' +
  '  overflow: hidden;' +
  '  position: absolute;' +
  '  left: 7px;' +
  '  top: 7px;' +
  '  width: 10px;' +
  '  height: 10px;' +
  '  background-position: -65px 0;' +
  '  vertical-align: top;' +
  "  content: '';" +
  '}' +
  '.ac_panel .ac_line_wrap {' +
  '  margin: 17px 0 19px;' +
  '  padding-top: 7px;' +
  '  padding-bottom: 7px;' +
  '}' +
  '.ac_panel .ac_line1 {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '  width: 100%;' +
  '  height: 1px;' +
  '  background-color: #e4e4e6;' +
  '  outline-style: none;' +
  '}' +
  '.ac_panel .ac_tit_main {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '  min-height: 22px;' +
  '  margin-top: 27px;' +
  '  padding-top: 3px;' +
  '  padding-bottom: 1px;' +
  '  font-size: 20px;' +
  '  font-weight: bold;' +
  '  line-height: 26px;' +
  '  color: #222529;' +
  '  word-break: break-all;' +
  '  outline-style: none;' +
  '}' +
  '.ac_panel .ac_tit_main:before {' +
  '  display: block;' +
  '  position: absolute;' +
  '  left: 0;' +
  '  top: -5px;' +
  '  width: 15px;' +
  '  height: 1px;' +
  '  background-color: #222529;' +
  "  content: '';" +
  '}' +
  '.ac_panel.ac_align_center .ac_tit_main:before {' +
  '  left: 50%;' +
  '  margin-left: -8px;' +
  '}' +
  '.ac_panel .ac_tit_sub {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '  min-height: 20px;' +
  '  margin-top: 10px;' +
  '  padding-top: 3px;' +
  '  padding-bottom: 2px;' +
  '  font-size: 17px;' +
  '  font-weight: bold;' +
  '  line-height: 24px;' +
  '  color: #444;' +
  '  word-break: break-all;' +
  '  outline-style: none;' +
  '}' +
  '.ac_panel .ac_text {' +
  '  position: relative;' +
  '  z-index: 10;' +
  '  min-height: 19px;' +
  '  margin-top: 8px;' +
  '  padding-top: 4px;' +
  '  padding-bottom: 2px;' +
  '  font-size: 16px;' +
  '  line-height: 24px;' +
  '  color: #444;' +
  '  word-break: break-all;' +
  '  outline-style: none;' +
  '}' +
  '.ac_panel .ac_comp_wrap:first-child .ac_tit_main {' +
  '  margin-top: 15px;' +
  '}' +
  '.ac_panel .ac_comp_wrap:first-child .ac_tit_sub,' +
  '.ac_panel .ac_comp_wrap:first-child .ac_text,' +
  '.ac_panel .ac_comp_wrap:first-child.ac_img_wrap,' +
  '.ac_panel .ac_comp_wrap:first-child.ac_line_wrap {' +
  '  margin-top: 0;' +
  '}' +
  '' +
  '#content.department .ac_panel .ac_pointer {' +
  '  color: #8452c7;' +
  '}' +
  '' +
  '#content.outlet .ac_panel .ac_pointer {' +
  '  color: #6456d6;' +
  '}' +
  '' +
  '#content.style .ac_panel .ac_pointer {' +
  '  color: #bd57e3;' +
  '}' +
  '' +
  '#content.fashion_brand .ac_panel .ac_pointer {' +
  '  color: #bd57e3;' +
  '}' +
  '' +
  '#content.designer .ac_panel .ac_pointer {' +
  '  color: #212121;' +
  '}' +
  '' +
  '#content.beauty .ac_panel .ac_pointer {' +
  '  color: #f261b6;' +
  '}' +
  '' +
  '#content.living .ac_panel .ac_pointer {' +
  '  color: #c7984f;' +
  '}' +
  '' +
  '#content.direct_farm .ac_panel .ac_pointer {' +
  '  color: #6cb43b;' +
  '}' +
  '' +
  '#content.local_food .ac_panel .ac_pointer {' +
  '  color: #6cb43b;' +
  '}' +
  '' +
  '#content.traditional_alcohol .ac_panel .ac_pointer {' +
  '  color: #d99c89;' +
  '}' +
  '' +
  '#content.home_meal .ac_panel .ac_pointer {' +
  '  color: #fe5b06;' +
  '}' +
  '' +
  '#content.kids .ac_panel .ac_pointer {' +
  '  color: #fab800;' +
  '}' +
  '' +
  '#content.pet .ac_panel .ac_pointer {' +
  '  color: #6876e0;' +
  '}' +
  '' +
  '#content.play .ac_panel .ac_pointer {' +
  '  color: #3682d5;' +
  '}' +
  '' +
  '#content.art .ac_panel .ac_pointer {' +
  '  color: #80b166;' +
  '}' +
  '' +
  '#content.foreign .ac_panel .ac_pointer {' +
  '  color: #732938;' +
  '}'

export const commonCss =
  // tslint:disable-next-line:prefer-template
  'body,' +
  'p,' +
  'h1,' +
  'h2,' +
  'h3,' +
  'h4,' +
  'h5,' +
  'h6,' +
  'ul,' +
  'ol,' +
  'li,' +
  'dl,' +
  'dt,' +
  'dd,' +
  'table,' +
  'th,' +
  'td,' +
  'form,' +
  'fieldset,' +
  'legend,' +
  'input,' +
  'textarea,' +
  'button,' +
  'select {' +
  '  margin: 0;' +
  '  padding: 0;' +
  '}' +
  '' +
  'body,' +
  'input,' +
  'textarea,' +
  'select,' +
  'button,' +
  'table {' +
  '  font-family: HelveticaNeue, AppleSDGothicNeo, sans-serif;' +
  '  font-size: 14px;' +
  '  line-height: 1.25em;' +
  '}' +
  '' +
  'body {' +
  '  position: relative;' +
  '  width: 100%;' +
  '  -webkit-text-size-adjust: none;' +
  '}' +
  '' +
  'img,' +
  'fieldset {' +
  '  border: 0;' +
  '}' +
  '' +
  'ul,' +
  'ol {' +
  '  list-style: none;' +
  '}' +
  '' +
  'em,' +
  'address {' +
  '  font-style: normal;' +
  '}' +
  '' +
  'a {' +
  '  color: inherit;' +
  '  text-decoration: none;' +
  '  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);' +
  '}' +
  '' +
  'a:active {' +
  '  background-color: rgba(0, 0, 0, 0.1);' +
  '}' +
  '' +
  'table {' +
  '  border-collapse: collapse;' +
  '}' +
  '' +
  'hr {' +
  '  display: none !important;' +
  '}' +
  '' +
  'button {' +
  '  border: 0 none;' +
  '  background: transparent;' +
  '  outline: none;' +
  '}' +
  '' +
  '.blind {' +
  '  overflow: hidden;' +
  '  position: absolute;' +
  '  clip: rect(0 0 0 0);' +
  '  width: 1px;' +
  '  height: 1px;' +
  '  margin: -1px;' +
  '}'
